import { useEdgeGroups } from '@/react/edge/edge-groups/queries/useEdgeGroups';
import { EdgeGroup } from '@/react/edge/edge-groups/types';

import { Badge } from '@@/Badge';
import { TooltipWithChildren } from '@@/Tip/TooltipWithChildren';

export function EdgeGroupLabels({
  edgeGroupIds,
}: {
  edgeGroupIds: Array<EdgeGroup['Id']>;
}) {
  const groupsQuery = useEdgeGroups({
    select: (groups) =>
      groups.filter((group) => edgeGroupIds.includes(group.Id)),
  });

  const edgeGroups = groupsQuery.data ?? [];
  return (
    <div className="flex gap-1">
      {edgeGroups
        ?.slice(0, 3)
        .map((group) => <Badge key={group.Id}>{group.Name}</Badge>)}

      {edgeGroups && edgeGroups.length > 3 && (
        <TooltipWithChildren
          message={edgeGroups
            .slice(3)
            .map((group) => group.Name)
            .join(', ')}
        >
          <div>
            <Badge>+{edgeGroups.length - 3} more...</Badge>
          </div>
        </TooltipWithChildren>
      )}
    </div>
  );
}
